import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {ExtendedGameMode} from "../server/ExtendedGameMode";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameUtils} from "../utils/GameUtils";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {HOTB} from "../HOTB";
import {HOTBData} from "../server/HOTBData";

export class GameSounds {
    public static GAME_INTRO: string = "gameStartOneShot";
    public static GAME_SPLASH_LOOP: string = "splashIntroLoop";
    public static PLACE_FEATURES_TOP_REEL: string = "conveyorAdd";
    public static PLACE_FEATURES_SIDE_REEL: string = "specialReelAdd";
    public static SYMS_EXPLODE: string = "symExplode";
    public static SYMS_LANDING: string[] = ["symLanding", "symLanding2"];
    public static DEAD_CRUSHED: string = "deadSymbolCrushed";
    // public static DEAD_CRUSHED_SKIP: string = "deadSymbolCrushedSkipClick";
    public static WAYS_COUNTER: string = "waysCounter";
    public static CONTINUE_BUTTON: string = "continueButton";
    public static LAUNCH_TO_WILD: string = "launchToWild";

    public static RAYS_START: string = "specialReelLightUp";
    public static SPLIT_START: string = "xSplitStart";
    public static SPLIT_END: string = "xSplitEnd";
    public static MULTIPLIER_SCOPE: string = "multiplierScope";
    public static MULTIPLIER_SHOT: string = "multiplierShot";
    public static MULTIPLIER_HIT: string = "launchWildHitByMulti";
    public static MAIN_GAME_MULTI_BOARD_UPDATE: string = "multisBoardUpdate";

    public static XBOMB_JUMP: string = "xBombJump";
    public static XBOMB_LAND: string = "xBombLand";
    public static XBOMB_EXPLODE: string = "xBombExplode";

    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    public static WIN_BLINK: string = "winBlink";
    public static WIN_TINY: string = "winTiny";
    public static WIN_SMALL: string = "winSmall";
    public static WIN_MEDIUM: string = "winMedium";
    public static WIN_LARGE_START: string = "winLargeCountUp";
    public static WIN_LARGE_END: string = "winLargeCountUpEnd";

    public static WILD_LAND: string = "wildLand";
    public static LAUNCH_LAND: string = "launchButtonLand";
    public static CAP_LAND: string = "capLanding";

    public static SCATTER_LAND: string[] = ["s1Land", "s2Land", "s3Land", "s4Land"];
    public static SCATTER_UPGRADE: string = "s4Upgrade";
    public static SCATTER_ANTICIPATION_LANDING: string[] = ["anticipationLand1", "anticipationLand2"];
    public static SCATTER_ANTICIPATION_END: string = "anticipationEnd";

    public static PRE_BIG_WIN: string = "preBigWin";
    public static PRE_BIG_WIN_2: string = "preBigWin2";
    public static BIG_WIN_LEVELS: string[] = ["bigWinLevel1", "bigWinLevel2", "bigWinLevel3", "bigWinLevel4", "bigWinLevel5"];
    public static BIG_WIN_LEVEL_CHANGE: string = "bigWinLevelChange";
    public static BIG_WIN_END: string = "bigWinEnd";


    public static XNUDGE_DROP: string = "xNudgeDropDown";
    public static XNUDGE_STEP_1: string = "xNudgeNudge1";
    public static XNUDGE_STEP_2: string = "xNudgeNudge2";
    public static XNUDGE_STEP_3: string = "xNudgeNudge3";
    public static XNUDGE_EXPAND: string = "xNudgeNudgeToFull";

    public static MAIN_DOOR_OPEN: string = "doorsOpenMain";
    public static MAIN_DOOR_CLOSE: string = "doorsCloseMain";
    public static BONUS_DOOR_OPEN: string = "doorsOpenBonus";
    public static BONUS_DOOR_CLOSE: string = "doorsCloseBonus";
    public static MOVE_MAIN_FS: string = "movementMainToFS";
    public static MOVE_MAIN_SFS: string = "movementMainToSFS";
    public static MOVE_FS_MAIN: string = "movementFSToMain";
    public static MOVE_SFS_MAIN: string = "movementSFSToMain";
    public static MOVE_FS_SFS: string = "movementFSToSFS_renamed";
    public static MOVE_SKIP_FS: string = "movementSecondFloor";
    public static MOVE_SKIP_SFS: string = "movementThirdFloor";

    public static FS_INTRO_LOOP: string = "fsIntroLoop";
    public static SFS_INTRO_LOOP: string = "sfsIntroLoop";
    public static FS_OUTRO_LOOP: string = "fsOutroLoop";
    public static SFS_OUTRO_LOOP: string = "sfsOutroLoop";

    public static BONUS_OUTRO_END: string = "fsOutroEnd";
    public static BONUS_OUTRO_LARGE_END: string = "fsOutroLargeEnd";

    public static SATAN_SPIN_INTRO_LOOP: string = "satanSpinIntroLoop";
    public static SATAN_SPIN_LOOPS: string[] = ["satanSpinLoop1", "satanSpinLoop2", "satanSpinLoop3", "satanSpinLoop4", "satanSpinLoop5"];
    public static SATAN_SPIN_END: string = "satanSpinEnd";

    public static CAP_WIN_MACHINE_FAIL: string = "capWinMachineFail";
    public static CAP_WIN_MACHINE_GIVE_CAP: string = "capWinMachineGiveCap";
    public static CAP_WIN_MACHINE_INTRO_LOOP: string = "capWinMachineIntroLoop";
    public static CAP_WIN_MACHINE_LOOP: string = "capWinMachineLoop";
    public static CAP_WIN_MACHINE_LOOP_AFTER_BUTTON_PRESS: string = "capWinMachineLoopAfterButtonPress";
    public static CAP_WIN_MACHINE_PRESS_BUTTON: string = "capWinMachinePressButton";
    public static CAP_WIN_MACHINE_GIVE_CAP_MAX: string = "capWinMachineGiveCapMax";
    public static CAP_WIN_MACHINE_LIGHT_FLICKER_START: string = "capWinMachineLightFlickerStart";
    public static CAP_WIN_MACHINE_LIGHT_OFF: string = "capWinMachineLightOff";
    public static CAP_WIN_MACHINE_MULTIPLIER_UPDATE: string = "capWinMachineMultiplierUpdate";

    public static WIN_CAP_SATAN_START: string = "winCapStart";
    public static WIN_CAP_SATAN_COUNT_UP: string = "winCapCountUp";
    public static WIN_CAP_SATAN_LOOP: string = "winCapLoop";
    public static WIN_CAP_SATAN_END: string = "winCapEnd";
    public static WIN_CAP_SATAN_EXPLOSION: string = "winCapExplosion";
    public isSideReelSoundPlaying: boolean = false;
    public satanSpinSoundPlaying: string = "";
    private PLAYING_LOOP_EFFECTS: string[] = [];
    private MAIN_GAME_MUSIC: string = "background-music-main";
    private FS_GAME_MUSIC: string = "background-music-freespin";
    private SFS_GAME_MUSIC: string = "background-music-superfreespin";
    private SYM_FALL_OUT: string = "symsFallOut";
    private _currentMusic: string;
    private _activatedSideReelFeatureSounds: string[] = [];

    private _prevAnticipationLandingSound: string = "";

    constructor() {
        if (NolimitConfig.isDevMode) {
            GameSounds.soundPlayer.showLogs(true);
        }
        NolimitSlotAudio.apiPlugIn.settings.on(APISetting.SFX, (value: any) => this.onSFX(value));
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public fadeMusic(vol: number, duration: number): void {
        Logger.logDev("sound fadeMusic: ", this._currentMusic, " vol:", vol, " duration:", duration);
        GameSounds.soundPlayer.fadeTrack({
            name: this._currentMusic,
            to: vol,
            duration: duration
        });
    }

    public playSound(name: string, volume?: number, repeat?: number): void {
        if (GameUtils.isCapMachineGame() &&
            (GameSounds.SYMS_LANDING.includes(name) || name === this.SYM_FALL_OUT || name === GameSounds.PLACE_FEATURES_TOP_REEL)) {
            return;
        }

        GameSounds.soundPlayer.playTrack({
            name: name,
            volume: volume,
            repeat: repeat
        });
    }

    public stopSound(name: string): void {
        GameSounds.soundPlayer.stopTrack(name);
    }

    public switchMusic(mode: ExtendedGameMode | string, vol: number = 1): void {
        let nextMusic: string;

        switch (mode) {
            case ExtendedGameMode.FREESPIN:
            case ExtendedGameMode.FREESPIN_AVALANCHE:
                nextMusic = this.FS_GAME_MUSIC;
                break;
            case ExtendedGameMode.FREESPIN_SUPER:
            case ExtendedGameMode.FREESPIN_SUPER_AVALANCHE:
                nextMusic = this.SFS_GAME_MUSIC;
                break;
            case ExtendedGameMode.CAPWIN_GAME:
                nextMusic = this.handleMusicInCapWinMachine();
                break;
            default:
                nextMusic = this.MAIN_GAME_MUSIC;
                break;
        }

        const activeBetFeature: BetFeature | undefined = GameUtils.getActiveBetFeature();
        if (activeBetFeature) {
            nextMusic = this.handleMusicInActiveBetFeature(activeBetFeature, nextMusic)
        }

        if (nextMusic === this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            if (this._currentMusic === GameSounds.SATAN_SPIN_INTRO_LOOP || this._currentMusic === GameSounds.CAP_WIN_MACHINE_INTRO_LOOP) {
                this.stopLoopEffect(this._currentMusic);
            } else {
                GameSounds.soundPlayer.stopTrack(this._currentMusic);
            }
        }

        if (activeBetFeature && (activeBetFeature.name === "SATAN_SPINS" || activeBetFeature.name === ExtendedGameMode.CAPWIN_GAME)) {
            this.playLoopEffect(nextMusic, vol);
        } else {
            this.playSound(nextMusic, vol, undefined);
        }
        this._currentMusic = nextMusic;
    }

    // play loop effect even the trigger is when sound is off, it will play when sound is on.
    public playLoopEffect(name: string, vol: number = 1): void {
        if (this.PLAYING_LOOP_EFFECTS.indexOf(name) === -1) {
            this.PLAYING_LOOP_EFFECTS.push(name);
        }
        const currPlayer: NolimitHowl | undefined = GameSounds.soundPlayer.fetchSoundPlayer(name);
        if (currPlayer && !currPlayer.isPlaying) {
            GameSounds.soundPlayer.playTrack({name: name, volume: vol, repeat: Number.MAX_VALUE});
        }
    }

    public stopLoopEffect(name: string): void {
        ArrayHelper.removeFirstMatchElement(this.PLAYING_LOOP_EFFECTS, name);
        this.stopSound(name);
    }

    public onSpinStart(): void {
        this.playSound(this.SYM_FALL_OUT);
    }

    public playSideReelFeatureSounds(soundName: string): void {
        if (!this._activatedSideReelFeatureSounds.includes(soundName)) {
            this._activatedSideReelFeatureSounds.push(soundName);
            this.playSound(soundName);
        }
    }

    public stopSideReelFeatureSounds(): void {
        this._activatedSideReelFeatureSounds.forEach((soundName: string): void => {
            this.stopSound(soundName);
        })
    }

    public reset(): void {
        this.isSideReelSoundPlaying = false;
        this._activatedSideReelFeatureSounds = [];
    }

    public playSatanSpinSounds(): void {
        if (!GameSounds.SATAN_SPIN_LOOPS.length) {
            GameSounds.SATAN_SPIN_LOOPS = ["satanSpinLoop1", "satanSpinLoop2", "satanSpinLoop3", "satanSpinLoop4", "satanSpinLoop5"];
        }
        this.satanSpinSoundPlaying = this.playRandomSoundWithoutRepeat(GameSounds.SATAN_SPIN_LOOPS, true);
    }

    public playScatterAnticipationLandingSounds(): void {
        if (this._prevAnticipationLandingSound && this._prevAnticipationLandingSound === GameSounds.SCATTER_ANTICIPATION_LANDING[0]) {
            this._prevAnticipationLandingSound = GameSounds.SCATTER_ANTICIPATION_LANDING[1];
        } else {
            this._prevAnticipationLandingSound = GameSounds.SCATTER_ANTICIPATION_LANDING[0];
        }

        this.playSound(this._prevAnticipationLandingSound);
    }

    public playRandomSoundWithoutRepeat(soundArr: string[], isRepeat: boolean = false): string {
        const randomNumber: number = Math.floor(Math.random() * soundArr.length);
        const sound: string = soundArr.splice(randomNumber, 1)[0];
        if (isRepeat) {
            this.playLoopEffect(sound);
        } else {
            this.playSound(sound);
        }
        return sound;
    }

    private handleMusicInCapWinMachine(): string {
        const data: HOTBData = HOTB.model.data,
            mode: ExtendedGameMode = data.mode,
            nextMode: ExtendedGameMode = data.nextMode;
        let nextMusic: string;

        if (mode === ExtendedGameMode.CAPWIN_GAME) {
            switch (nextMode) {
                case ExtendedGameMode.FREESPIN:
                    nextMusic = this.FS_GAME_MUSIC;
                    break;
                case ExtendedGameMode.FREESPIN_SUPER:
                    nextMusic = this.SFS_GAME_MUSIC;
                    break;
                default:
                    nextMusic = this.MAIN_GAME_MUSIC;
                    break;
            }
        } else {
            nextMusic = GameSounds.CAP_WIN_MACHINE_LOOP;
        }

        return nextMusic;
    }

    private handleMusicInActiveBetFeature(activeBetFeature: BetFeature, nextMusic: string): string {
        switch (activeBetFeature.name) {
            case ("SATAN_SPINS"):
                nextMusic = GameSounds.SATAN_SPIN_INTRO_LOOP;
                break;
            case (ExtendedGameMode.CAPWIN_GAME):
                nextMusic = GameSounds.CAP_WIN_MACHINE_INTRO_LOOP;
                break;
        }

        return nextMusic;
    }

    private onSFX(value: any): void {
        if (!(GameSounds.soundPlayer.isLoaded)) {
            return;
        }
        if (!NolimitSlotAudio.apiPlugIn.settings.get("mute")) {
            return;
        }
        if (!value) {
            return;
        }
        this.PLAYING_LOOP_EFFECTS.forEach(name => {
            this.playLoopEffect(name);
        });
    }
}